export default class ReducerContainer {
  static create() {
    const reducers = {};

    return {
      add(actionType, reducer) {
        reducers[actionType] = reducer;
      },
      exist(actionType) {
        return reducers.hasOwnProperty(actionType);
      },
      getNextState(type, state, payload) {
        const reducer = reducers[type];
        return reducer ? reducer(state, payload) : null;
      },
    };
  }

  static createReducer(initialState, handlers) {
    if (!initialState || !handlers) {
      throw new Error('must pass args of "initialState" and "handlers" to createReducer!');
    }

    return (state = initialState, { type, payload }) => {
      const handler = handlers[type];

      if (typeof handler !== 'function') {
        return state;
      }

      return handler(state, payload);
    };
  }

  static appendReducer(masterReducer, ...reducers) {
    return function (state, action) {
      const nextState = masterReducer(state, action);

      return reducers.reduce((currentState, reducer) => reducer(currentState, action), nextState);
    };
  }
}




// WEBPACK FOOTER //
// ./src/helper/reducer-helper.js